import EntityList from './../../entities/entity-list';
import BlockRange from './../../block-range';
import BlockMutationResult from './../../block-mutation-result';
import PropertyCleaners from './../../mixins/property-cleaners';
import { computed } from '@ember/object';
import { notImplemented } from '@intercom/pulse/lib/computed-properties';
import Constants from '@intercom/embercom-composer/lib/constants';
import HTMLGenerator from '@intercom/embercom-composer/lib/html-generator';
import { expandToSurrogatePairs } from '@intercom/embercom-composer/lib/unicode';
import $ from 'jquery';
import { empty, not, reads } from '@ember/object/computed';
import Em from 'ember';
import { importSync } from '@embroider/macros';
export function classForType(type) {
  let OrderedList = importSync('@intercom/embercom-composer/blocks/types/ordered-list').default;
  let UnorderedList = importSync('@intercom/embercom-composer/blocks/types/unordered-list').default;
  let ListItem = importSync('@intercom/embercom-composer/blocks/types/list-item').default;
  let Paragraph = importSync('@intercom/embercom-composer/blocks/types/paragraph').default;
  let Img = importSync('@intercom/embercom-composer/blocks/types/image').default;
  let VideoFile = importSync('@intercom/embercom-composer/blocks/types/video-file').default;
  let Heading = importSync('@intercom/embercom-composer/blocks/types/heading').default;
  let Subheading = importSync('@intercom/embercom-composer/blocks/types/subheading').default;
  let Code = importSync('@intercom/embercom-composer/blocks/types/code').default;
  let ButtonBlock = importSync('@intercom/embercom-composer/blocks/types/button').default;
  let Video = importSync('@intercom/embercom-composer/blocks/types/video').default;
  let FacebookLikeButton = importSync('@intercom/embercom-composer/blocks/types/facebook-like-button').default;
  let TwitterFollowButton = importSync('@intercom/embercom-composer/blocks/types/twitter-follow-button').default;
  let Html = importSync('@intercom/embercom-composer/blocks/types/html').default;
  let Link = importSync('@intercom/embercom-composer/blocks/types/link').default;
  let MessengerCard = importSync('@intercom/embercom-composer/blocks/types/messenger-card').default;
  let ImageText = importSync('@intercom/embercom-composer/blocks/types/image-text').default;
  switch (type.toLowerCase() //TODO: GJ: remove the need for the `toLower`
  ) {
    case 'unorderedlist':
      return UnorderedList;
    case 'orderedlist':
      return OrderedList;
    case 'paragraph':
      return Paragraph;
    case 'image':
      return Img;
    case 'videofile':
      return VideoFile;
    case 'heading':
      return Heading;
    case 'subheading':
      return Subheading;
    case 'code':
      return Code;
    case 'listitem':
      return ListItem;
    case 'button':
      return ButtonBlock;
    case 'video':
      return Video;
    case 'facebooklikebutton':
      return FacebookLikeButton;
    case 'twitterfollowbutton':
      return TwitterFollowButton;
    case 'html':
      return Html;
    case 'link':
      return Link;
    case 'messengercard':
      return MessengerCard;
    case 'imagetext':
      return ImageText;
    default:
      throw new Error(`Unknown block type ${type}`);
  }
}
export default Em.Object.extend(PropertyCleaners, {
  allowedEntities: [],
  id: null,
  text: '',
  isEditable: true,
  isBlock: true,
  generatedAt: Em.computed('innerHtml', 'align', function () {
    return String(Date.now()) + String(Math.random());
  }),
  openingTag: computed('tagName', 'id', 'generatedAt', function () {
    return `<${this.tagName} data-id="${this.id}" data-generated-at="${this.generatedAt}">`;
  }),
  closingTag: computed('tagName', function () {
    return `</${this.tagName}>`;
  }),
  type: notImplemented('type is not implemented'),
  entities: null,
  hasNoEntities: empty('entities'),
  hasMarkers: reads('entities.hasMarkers'),
  isEmpty: empty('trimmedText'),
  trimmedText: Em.computed('text', function () {
    let text = this.get('text') || '';
    return text.trim();
  }),
  isNotEmpty: not('isEmpty'),
  isBlank: Em.computed('text', function () {
    return Em.isBlank(this.get('text'));
  }),
  html: computed('openingTag', 'innerHtml', 'closingTag', function () {
    return `${this.openingTag}${this.innerHtml}${this.closingTag}`;
  }),
  endItemIndex: 0,
  endPositionIndex: reads('text.length'),
  _zeroWidthSpace: `<zws>${Constants.ZERO_WIDTH_SPACE}</zws>`,
  _paragraphInserter: '<insert contenteditable=false><insert-point></insert-point></insert>',
  init() {
    if (Em.isEmpty(this.get('config'))) {
      throw new Error('Config is required when creating a block');
    }
    this.set('id', `block-${Em.guidFor(this)}`);
    let parseResult = EntityList.parseEntities(this.get('text'), this.get('allowedEntities'), this.get('config'));
    this.set('entities', parseResult.get('entityList'));
    this.set('text', parseResult.get('cleanedText'));
    this.autoCenter();
  },
  serialized: notImplemented('serialized is not implemented'),
  autoCenter() {
    let autoCenter = this.get('config.autoCenter');
    if (this.get('canAlign') && autoCenter && autoCenter.includes(this.get('type')) && !this.get('align')) {
      this.set('align', 'center');
    } else if (this.get('canAlign') && !this.get('align')) {
      this.set('align', 'left');
    }
  },
  innerHtml: Em.computed('text', 'entities.@each.{startIndex,endIndex,url,href,fallback}', function () {
    let result = '';
    Em.instrument('Composer.block.innerHtml', null, function () {
      let text = this.get('text') || '';
      let entities = this.get('entities');
      let generator = new HTMLGenerator(text, entities, {
        target: 'editor'
      });
      result = generator.getHtml();
    }, this);
    return result;
  }),
  //TODO: GJ: enitites should expose a standard CP which can be subscribed to

  serializedInnerHtml: Em.computed('text', 'entities.@each.{startIndex,endIndex,url,href,fallback}', function () {
    let result = '';
    Em.instrument('Composer.block.serializedHtml', null, function () {
      let text = this.get('text') || '';
      let entities = this.get('entities');
      let generator = new HTMLGenerator(text, entities, {
        target: 'serialized'
      });
      result = generator.getHtml();
    }, this);
    return result;
  }),
  //TODO: GJ: enitites should expose a standard CP which can be subscribed to,

  cleanData() {},
  applyAction(action, blockRange, options) {
    if ($.isFunction(this[action])) {
      return this[action](blockRange, options);
    }
    return BlockMutationResult.create({});
  },
  toggleEntity(type, blockRange, options) {
    if (!this.canApplyEntity(type)) {
      return BlockMutationResult.create({});
    }
    let added = this.get('entities').toggle(type, blockRange, options);
    return BlockMutationResult.create({
      added
    });
  },
  addEntity(type, blockRange, options) {
    if (!this.canApplyEntity(type)) {
      return BlockMutationResult.create({});
    }
    this.get('entities').add(type, blockRange, options);
    return BlockMutationResult.create();
  },
  removeEntity(type, blockRange, options) {
    if (!this.canApplyEntity(type)) {
      return BlockMutationResult.create({});
    }
    this.get('entities').remove(type, blockRange, options);
    return BlockMutationResult.create();
  },
  canApplyEntity(type) {
    let t = Em.String.capitalize(type);
    return this.get('allowedEntities').includes(type) && this.get(`config.allow${t}`);
  },
  join() {
    return BlockMutationResult.create({
      blocksToRemove: [this],
      blockRange: BlockRange.atPositionIndex(0)
    });
  },
  delete(blockRange) {
    let text = this.get('text');
    expandToSurrogatePairs(blockRange, text);
    this.expandToAttribute(blockRange);
    this._updateEntitiesForDelete(blockRange);
    text = this.get('text');
    let startIndex = blockRange.get('startPoint.positionIndex');
    let endIndex = blockRange.get('endPoint.positionIndex');
    this._checkIndexIsInRange(startIndex, text.length, 'delete');
    this._checkIndexIsInRange(endIndex, text.length, 'delete');
    text = text.slice(0, startIndex) + text.slice(endIndex);
    let newBlockRange = BlockRange.atPositionIndex(startIndex);
    if (startIndex === text.length && this.get('entities').segregatedWithinRange(newBlockRange).length > 0) {
      this.set('text', `${text} `);
    } else {
      this.set('text', text);
    }
    let mutationResult = BlockMutationResult.create({
      blockRange: newBlockRange
    });
    this.doInlineReplacements(mutationResult);
    return mutationResult;
  },
  doInlineReplacements() {},
  expandToAttribute(blockRange) {
    if (blockRange.get('length') === 1) {
      let attributeEntities = this.get('entities').byTypeWithinRange('attribute', blockRange);
      if (attributeEntities.length === 0) {
        return;
      }
      let attribute = attributeEntities.get('firstObject');
      if (attribute.intersectsRight(blockRange)) {
        blockRange.set('endPoint.positionIndex', attribute.endIndex);
      }
      if (attribute.intersectsLeft(blockRange)) {
        blockRange.set('startPoint.positionIndex', attribute.startIndex);
      }
    }
  },
  insert() {
    throw new Error('Insert has not been implemented');
  },
  hasSameEntitiesAs(block) {
    return EntityList.compare(this.get('entities'), block.get('entities'));
  },
  hasEntityTypeInRange(entityType, blockRange) {
    return !!this.get('entities').byTypeWithinRange(entityType, blockRange).length;
  },
  hasEntityOfTypeCoveringRange(entityType, blockRange) {
    return !!this.get('entities').byTypeCoveringRange(entityType, blockRange).length;
  },
  isSameTypeAs(block) {
    return block.get('type') === this.get('type');
  },
  findBlockById() {},
  findEntityById(id) {
    if (this.get('entities')) {
      return this.get('entities.content').findBy('id', id);
    }
    return null;
  },
  deleteEntityById(id) {
    let entity = this.findEntityById(id);
    if (entity) {
      this.get('entities').removeObject(entity);
    }
  },
  _updateEntitiesForDelete(blockRange, newBlockRange) {
    this.get('entities').updateForDelete(this, blockRange, newBlockRange);
  },
  _updateEntitiesAfterInlineReplacement(startIndex, matchLength, replacementLength) {
    let deleteEndsAt = startIndex + matchLength;
    let deleteStartsAt = deleteEndsAt - (matchLength - replacementLength);
    if (deleteStartsAt < deleteEndsAt) {
      this._updateEntitiesForDelete(BlockRange.atPositionIndex(deleteStartsAt, deleteEndsAt), BlockRange.atPositionIndex(deleteStartsAt));
    }
    if (deleteStartsAt > deleteEndsAt) {
      throw new Error('replacements that result in a longer string are not currently handled');
    }
  },
  _checkIndexIsInRange(index, length, caller) {
    if (index < 0 || index > length) {
      throw new Error(`${caller} index out of bounds [${index}]. Valid range is [0-${length}]`);
    }
  }
});